<template>
    <div id="paymentday">
    <div class="table-box">
        <div class="table-head">
          <div style="margin-left:13px;">
            <i class="iconfont icon-liebiao" style="color:#666666"></i> 数据列表
          </div>
          <el-button class="add-btn" size="small" @click="centerDialogVisible = true">添加</el-button>
        </div>
        <div class="table">
          <template>
            <el-table
              :header-cell-style="{
                'background-color': '#F5FAF9'
                }"
              :data="tableData"
              border
              style="width: 100%"
            >
              <el-table-column align="center" prop="days" label="账期/天" width="185"></el-table-column>
              <el-table-column align="center" prop="interest" label="费率"></el-table-column>
              <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                      <el-link @click="delPayment(scope.row.days)">删除</el-link>
                  </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <el-dialog
            title="添加账期"
            :visible.sync="centerDialogVisible"
            width="20%"
            center>
            <el-form status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="账期/天" prop="pass">
                    <el-input-number v-model="days" :step="1" step-strictly></el-input-number>
                </el-form-item>
                <el-form-item label="费率" prop="checkPass">
                    <el-input-number v-model="interest" :precision="2" :step="0.1" :max="10"></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addPayment">确 定</el-button>
            </span>
        </el-dialog>
    </div>   
    </div>
</template>

<script>
export default {
    
    data () {
       return {
           serve: this.$store.state.serve,
           token: this.$cookies.get('shop_token'),
           centerDialogVisible: false,
           tableData: [],
           days: 0,
           interest: 0,
       }
    },
    created () {
        this.$store.state.shop_top = 3;
        this.$store.state.shop_left = "账期设置";
        this.paymentInfo();
    },
    methods: {
        paymentInfo () {
            this.axios.get(this.serve + 'shop/paymentDayInfo',{
               params:{
                   token: this.token
               } 
           }).then(res => {
                let re = res.data;
                if(re.status == 'success'){
                    this.tableData = re.data;
                }
           })
        },
        addPayment () {
           this.axios.get(this.serve + 'shop/addPayment',{
               params:{
                   token: this.token,
                   days:this.days,
                   interest: this.interest
               } 
           }).then(res => {
                let re = res.data;
                if(re.status == 'success'){
                    this.$message({
                        type: 'success',
                        message: re.msg
                    });        
                    this.paymentInfo();
                    this.centerDialogVisible = false;
                }else{
                    this.$message({
                        type: 'error',
                        message: re.msg
                    }); 
                    this.centerDialogVisible = false;
                }
           })
        },
        delPayment (days) {
           
           this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => { 
                this.axios.get(this.serve + 'shop/delPayment',{
                    params:{
                        token: this.token,
                        days:days,
                    } 
                }).then(res => {
                    let re = res.data;
                    if(re.status == 'success'){
                        this.$message({
                            type: 'success',
                            message: re.msg
                        });        
                        this.paymentInfo();
                    }else{
                        this.$message({
                            type: 'error',
                            message: re.msg
                        }); 
                    }
                })
            }).catch(() => {
           this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
        }
    }
}
</script>

<style lang="scss" scoped>
.table-box {
    margin-top: 19px;
    margin-bottom: 100px;
    .table-head {
      width: 1060px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .table {
      width: 1062px;
    }
    .page-box {
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 60px;
      display: flex;
      justify-content: flex-end;
    }
  }
.el-table .cell a{
   margin-right: 5px;
}
.add-btn{
    margin-right: 10px;
}
</style>